import apiClient, { extractData } from "../api-client";

// Tab "Chuyền sản xuất" trong trang Tiến độ sản xuất (/delivery-schedule?tab=lines).
export const productionLinesApi = {
  get() {
    return apiClient.get("/production-lines").then(extractData);
  },
  // Chỉ admin — backend chặn quản đốc. Trả lại toàn bộ dữ liệu trang như get().
  updateConfig(payload) {
    return apiClient.put("/production-lines/config", payload).then(extractData);
  },
};

export default productionLinesApi;
